import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BuildChildren from 'utils/BuildChildren';
import DropdownA from 'components/Dropdown/DropdownA';
import { priceFormatter } from 'utils/Numbers';
import { buildProductListStructuredData } from 'utils/StructuredData';
import { find, findIndex } from 'lodash';
import AffirmContainer from 'containers/AffirmContainer/AffirmContainer';
import classes from './CardProductGList.module.scss';

class CardProductGList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedIndex: -1,
    };

    this.onSelect = this.onSelect.bind(this);
  }

  onSelect = (details) => {
    const { items = [] } = this.props;
    this.setState({ selectedIndex: details ? findIndex(items, (obj) => obj.productId === details.productId) : -1 });
  }

  render() {
    let { items = [] } = this.props;

    const listDisplay = (item) => (
      <span className={classes.optionWrapper}>
        {item.displayName &&
        <span
          className={classes.dropdownDisplayName}
          dangerouslySetInnerHTML={{ __html: item.displayName }}
        />}
        <span className={classes.dropdownPrice}>{priceFormatter(item.price)}
          {item.originalPrice > item.price &&
            <span className={classes.dropdownOriginalPrice}>{priceFormatter(item.originalPrice)}</span>}
        </span>
      </span>
    );

    const singleValue = (item) => (
      <span className={classes.singleValueWrapper}>
        {item.displayName &&
        <span
          className={classes.dropdownDisplayName}
          dangerouslySetInnerHTML={{ __html: item.displayName }}
        />}
      </span>
    );

    items = items.map((item) => ({
      ...item,
      label: item.displayName,
      renderSingleValue: singleValue(item),
      renderOption: listDisplay(item),
    }));

    const { selectedIndex } = this.state;

    const selectedItem = selectedIndex > -1 ? items[selectedIndex] : null;

    const {
      price,
      originalPrice,
      button,
      isAffirmEligible,
    } = selectedIndex > -1 && selectedItem;

    // Set Image, Header and Content properties to first one found in list since not all products will have these
    const firstItem = find(items, (obj) => obj.imageURI !== '') || null;

    const {
      imageURI,
      imageAltText = '',
      imageHeight,
      imageWidth,
      heading,
      content,
    } = firstItem || {};

    // Image information is needed here for structured data methods
    items = items.map((item) => ({
      ...item,
      imageURI,
      imageAltText,
      imageHeight,
      imageWidth,
    }));

    const structuredData = buildProductListStructuredData(items);

    return (
      <div className={classes.container}>
        <div className={classes.wrapper}>
          <script
            type='application/ld+json'
            dangerouslySetInnerHTML={{ __html: structuredData }}
          />
          <div className={classes.imageContainer}>
            {imageURI &&
              <img
                className={classes.image}
                src={imageURI}
                alt={imageAltText}
                width={imageWidth}
                height={imageHeight}
                loading='lazy'
              />}
          </div>
          <div className={classes.infoContainer}>
            {heading &&
            <h2
              className={classes.heading}
              dangerouslySetInnerHTML={{ __html: heading }}
            />}
            {content &&
            <div
              className={classes.content}
              dangerouslySetInnerHTML={{ __html: content }}
            />}
            {price >= 0 && <div className={classes.price}>{priceFormatter(price)}</div>}
            {originalPrice > price && <div className={classes.originalPrice}>{priceFormatter(originalPrice)}</div>}
            {price >= 0 &&
              <div className={classes.affirmMessage}>
                <AffirmContainer price={price} isAffirmEligible={isAffirmEligible} className={classes.affirmMessage} />
              </div>}
            <div className={classes.dropdownContainer}>
              <DropdownA
                type='CardProductGList'
                options={items}
                defaultValue={selectedItem}
                onChange={this.onSelect}
                renderOption='renderOption'
                renderSingleValue='renderSingleValue'
                isSearchable
                isClearable
                placeholder='Select'
              />
            </div>
            {button &&
              <div className={classes.buttonContainer}>
                {BuildChildren(button)}
              </div>}
          </div>
        </div>
      </div>
    );
  }
}

const itemT = PropTypes.shape({
  heading: PropTypes.string,
  content: PropTypes.string,
  imageURI: PropTypes.string,
  imageAltText: PropTypes.string,
  imageHeight: PropTypes.number,
  imageWidth: PropTypes.number,
  displayName: PropTypes.string,
  description: PropTypes.string,
  price: PropTypes.number,
  originalPrice: PropTypes.number,
  button: PropTypes.object,
  isAffirmEligible: PropTypes.bool,
});

CardProductGList.propTypes = {
  /**
   * Array of products in the list
  */
  items: PropTypes.arrayOf(itemT),
};

export default CardProductGList;
